import * as S from './LTHeader.styled';

type Props = {
    children: React.ReactNode;
    style?: React.CSSProperties;
    flexStart?: boolean;
    innerStyle?: React.CSSProperties;
};

const LTHeader = ({ children, style, flexStart, innerStyle }: Props) => {
    return (
        <S.OuterDiv
            style={{
                ...style,
            }}
        >
            <S.InnerDiv flexStart={flexStart ? flexStart : false} style={innerStyle}>
                {children}
            </S.InnerDiv>
        </S.OuterDiv>
    );
};

export { LTHeader };
